import * as React from 'react';

import * as Edge from '../../../core';
import PerformanceSummary from '../../../components/performanceSummary';
import { AppState } from '../../../store';
import { connect } from 'react-redux';

import './index.scss';

interface EdgeScoreProps {
	currentTeam?: Edge.Models.Team;
	isCurrTeamYouth?: boolean;
	sessions: Edge.Models.BaseSessionResponse[];
	viewingSelf: boolean;
}

export class AthleteStatsEdgeScore extends React.Component<EdgeScoreProps> {
	public render(): JSX.Element {
		const { currentTeam, sessions } = this.props;

		if (currentTeam && currentTeam.type.id === Edge.Models.TeamTypeId.StationMode) {
			return (
				<div className="my_plan_comp">
					Not available in Station Mode. To upgrade this account, please contact{' '}
					<a href={'mailto:support@vizualedge.com'}>support@vizualedge.com</a>.
				</div>
			);
		}

		if (sessions.length < 1) {
			return <>There are no evaluation results to display.</>;
		}

		return (
			<div className="edge_score_stat">
				<div className="inner_content">
					<PerformanceSummary embedded sessions={sessions} showProCompare={this.props.isCurrTeamYouth} />
				</div>
			</div>
		);
	}
}

function mapStateToProps({ teamState }: AppState) {
	const isCurrTeamYouth = teamState.currentTeam && teamState.currentTeam!.level.id === Edge.Models.LevelId.Youth;

	return {
		isCurrTeamYouth,
	};
}

export default connect(mapStateToProps)(AthleteStatsEdgeScore);
